import { Icon } from '@design-system';
import Link from 'next/link';
import { FC } from 'react';

import { LocationItemStoryblok } from '../../types/generated-storyblok';

interface Props {
  blok: LocationItemStoryblok;
}

export const ArticleLocation: FC<Props> = ({ blok }) => (
  <Link
    className="group flex gap-3 pt-3 first:pt-0 md:pt-4"
    href={blok.url.cached_url!}
    target="_blank"
  >
    <div className="text-active-4">{blok.id}</div>
    <div className="flex flex-grow flex-col group-hover:text-neutral-4">
      <div className="font-bold transition-colors">{blok.title}</div>
      <div className="transition-colors">{blok.description}</div>
    </div>
    <div className="flex h-9 w-9 flex-col items-center justify-center">
      <Icon name="ic_location" />
    </div>
  </Link>
);
